var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEqualCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.58065 3.58065 0 8 0C12.4194 0 16 3.58065 16 8C16 12.4194 12.4194 16 8 16C3.58065 16 0 12.4194 0 8ZM1.54839 8C1.54839 11.5645 4.43548 14.4516 8 14.4516C11.5645 14.4516 14.4516 11.5645 14.4516 8C14.4516 4.43548 11.5645 1.54839 8 1.54839C4.43548 1.54839 1.54839 4.43548 1.54839 8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33333 6H11.6667C11.8508 6 12 6.14917 12 6.33333V7C12 7.18417 11.8508 7.33333 11.6667 7.33333H4.33333C4.14917 7.33333 4 7.18417 4 7V6.33333C4 6.14917 4.14917 6 4.33333 6ZM4.33333 9.33333H11.6667C11.8508 9.33333 12 9.4825 12 9.66667V10.3333C12 10.5175 11.8508 10.6667 11.6667 10.6667H4.33333C4.14917 10.6667 4 10.5175 4 10.3333V9.66667C4 9.4825 4.14917 9.33333 4.33333 9.33333Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEqualCircle);
export default __webpack_public_path__ + "static/media/icon_equal_circle.a4c6e026d456ca0bbf05eadd8b45cbe6.svg";
export { ForwardRef as ReactComponent };